import { memo } from 'react';

import type { SectionSlotProps } from '@makemydeal/dr-sales-checkin-types';
import { getPlaceholderHeight } from '@makemydeal/dr-sales-checkin-ui-utils';

import { SkeletonSection } from '../SkeletonSection/SkeletonSection';
import { SectionAnchor } from './sectionSlot.style';

const SectionSlotComponent = ({ sectionKey, label, sectionRef, component: Section, isContentMounted }: SectionSlotProps) => (
    <SectionAnchor
        ref={sectionRef}
        data-section-key={sectionKey}
        data-testid={`showroom-section-${sectionKey}`}
        aria-label={label}
        tabIndex={-1}
    >
        {isContentMounted ? (
            <Section />
        ) : (
            <SkeletonSection
                minHeight={getPlaceholderHeight(sectionKey)}
                label={label}
                testId={`showroom-section-placeholder-${sectionKey}`}
            />
        )}
    </SectionAnchor>
);

export const SectionSlot = memo(SectionSlotComponent);
